import React, { Component } from 'react'
import { render } from 'react-dom';
import g from 'glamorous';
import qs from 'query-string';


import './styles/index.scss'
import UVNUtil from "../../components/uvn-resize"

//import Tracking from "@univision/fe-commons/dist/components/tracking/MainTracking"


class CalendarComponent extends Component {
	
	constructor(props) {
	  super(props);	
	  this.state = { countriesDisplay: false, stickyNav: false, socialShare: false, pageViewTracked: false, px: 0 };
	}

	isMobile () {
		let result = null
		if (typeof navigator !== 'undefined') {
			result = {
				Android: function() {
					return navigator.userAgent.match(/Android/i);
				},
				BlackBerry: function() {
					return navigator.userAgent.match(/BlackBerry/i);
				},
				iOS: function() {
					return navigator.userAgent.match(/iPhone|iPad|iPod/i);
				},
				Opera: function() {
					return navigator.userAgent.match(/Opera Mini/i);
				},
				Windows: function() {
					return navigator.userAgent.match(/IEMobile/i);
				},
				any: function() {
					return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows());
				}
			}
		}
		return {
			any: function () { return false; }
		};
    }

	set_content_type()  
	{
		try {
			utag.content_type = "slideshow";
			utag.primary_tag = "Calendario Mundial Rusia 2018";
		}catch(errr){}
	}
	track_click($tag_name)
	{
		if(window.parent != window && typeof window.postMessage != 'undefined') 
		{
			const __idframe = qs.parse(location.search).gatsby_iframe_id
			if(__idframe == undefined || __idframe == null) return;

			window.parent.postMessage({
				event: 'uvn-utag-track',
				content_type: {
					type : "slideshow",
					primary_tag : "Calendario Mundial Rusia 2018"
				},
				link: { 
					event : 'engagement', 
					promo_type : 'other', 
					promo_loc : 'http://www.univision.com/calendario-y-horarios-del-mundial-de-rusia-2018', 
					promo_name : $tag_name
				}
			}, "*");
		}
		else {
			this.set_content_type();
			try {
				utag.link({ 
					event : 'engagement', 
					promo_type : 'other', 
					promo_loc : 'http://www.univision.com/calendario-y-horarios-del-mundial-de-rusia-2018', 
					promo_name : $tag_name
				});
			} catch (error) { }
		}
		
	}
	track_middle()
	{
		if(window.parent != window && typeof window.postMessage != 'undefined') 
		{
			const __idframe = qs.parse(location.search).gatsby_iframe_id
			if(__idframe == undefined || __idframe == null) return;

			window.parent.postMessage({
				event: 'uvn-utag-track',
				link: {
					event : 'slide advance',
					slideshow_id : 'Calendario Mundial Rusia 2018',
					slideshow_image_id : 'Calendario Mundial Rusia 2018 - 1',
					slideshow_position : '1',
					slideshow_interact: 'scroll',
					slideshow_type: 'vertical'
				}
			}, "*");
		}
		else {
			try {
				utag.link({
					event : 'slide advance',
					slideshow_id : 'Calendario Mundial Rusia 2018',
					slideshow_image_id : 'Calendario Mundial Rusia 2018 - 1',
					slideshow_position : '1',
					slideshow_interact: 'scroll',
					slideshow_type: 'vertical'
				});
			} catch (error_utag) { }
		}
		this.state.pageViewTracked = true;
	}
	track_social(net)
	{
		if(window.parent != window && typeof window.postMessage != 'undefined') 
		{
			const __idframe = qs.parse(location.search).gatsby_iframe_id
			if(__idframe == undefined || __idframe == null) return;

			window.parent.postMessage({
				event: 'uvn-utag-track',
				link: {
					event : 'social share',
					social_network : net
				}
			}, "*");
		}
		else {
			utag.link({
				event : 'social share',
				social_network : net
			});
		}
	}

	componentDidMount()
	{
		if(window.parent != window && typeof window.postMessage != 'undefined') 
		{
			const __idframe = qs.parse(location.search).gatsby_iframe_id
			if(__idframe == undefined || __idframe == null) return;

			/*window.parent.postMessage({
				event: 'uvn-load-css',
				css: ".uvs-container article > div:nth-child(2){ display: none; }"
			}, "*");*/
		}
		this.set_content_type();
		
		window.addEventListener('scroll', ev => {

			var body = document.body,
				html = document.documentElement;
			
			var height = Math.max( body.scrollHeight, body.offsetHeight, 
								html.clientHeight, html.scrollHeight, html.offsetHeight );
			var current_top = Math.max( body.scrollTop, html.scrollTop);
			
			var percent_page_viewed = ((current_top / height) * 100);

			if ( (document.body.scrollTop > 280 || document.documentElement.scrollTop > 280) && percent_page_viewed < 70 ) {
				let uvnm = document.querySelector('.uvn-s-header-sticky');
				let height_tools = document.querySelector('.uvn-fifa2018-filters-cont');
				let sticy_height = document.querySelector('.stickyNav');
				this.setState({ 
					stickyNav: true, 
					sumTopsticky: uvnm != undefined  ? uvnm.clientHeight : 0,
					height_tools: height_tools != undefined ? height_tools.clientHeight + 5 : sticy_height.clientHeight,
					px: 5
				})
			} else {
				this.setState({ 
					stickyNav: false, 
					sumTopsticky: 0,
					height_tools: 0,
					px: 0
				})
			}
			
			if(!this.state.pageViewTracked)
			{				
				if(percent_page_viewed >= 40)
				{
					this.track_middle();
				}
			}
		})
	}
	
	selectView = (id, ev) => {
		
		ev.preventDefault()

		
		var $items = document.getElementsByClassName("uvn-fifa2018-view");
		for (let i = 0; i < $items.length; i++) {
			var element = $items[i];
			element.classList.remove("uvn-fifa2018-view-selected");
			
			if(element.classList.contains(id))
			{
				element.classList.add('uvn-fifa2018-view-selected');
			}
		}
		switch(id) {
			case "uvn-fifa2018-date":
				this.track_click('CalendarioRusia2018Fecha');
				this.props.gotoview('fechas');
				this.props.gotomatch(1);
				this.state.pageViewTracked = false;
			break;
			case "uvn-fifa2018-group":
				this.track_click('CalendarioRusia2018Grupos');
				this.props.gotoview('grupos');
				this.props.gotomatch(1);
				this.state.pageViewTracked = false;
			break;
			// case "uvn-fifa2018-country":
			// 	this.props.gotoview('pais')
			// break;
			default:
			break;		
		}
	}

	selectCategory = (id, ev) => {
		
		ev.preventDefault()	
		var $items = document.getElementsByClassName("category-icon");
		var option_selected = -1;
		
		if(id == 'dropdown-action')
			option_selected = document.getElementById('uvn-fifa2018-category-select').options[document.getElementById('uvn-fifa2018-category-select').selectedIndex].value;
		else
			option_selected = id;

		switch(option_selected) {
			case "trago-icon":
				this.track_click('CalendarioRusia2018Licor');
				this.props.gotocard(2)
			break;
			case "comida-icon":
				this.track_click('CalendarioRusia2018Comida');
				this.props.gotocard(0)				
			break;
			case "jugador-icon":
				this.track_click('CalendarioRusia2018Jugador');
				this.props.gotocard(1)				
			break;
			break;		
		}
		
		for (let i = 0; i < $items.length; i++) {
			var element = $items[i];
			element.classList.remove("uvn-fifa2018-list-category-selected");
			
			if(element.classList.contains(option_selected))
			{
				element.classList.add('uvn-fifa2018-list-category-selected');
			}
		}		
	}

	hideFlags = () => {
		this.setState({ countriesDisplay: false })
	}

	gotosocial = (ev) => {
		ev.preventDefault()
		this.setState({ socialShare: true })
	}

	hideSocial = (ev) => {
		this.setState({ socialShare: false })	
	}

	getOneTeamByCoutryCode(countryCode) {
		const { teams } = this.props.nodes.data.matchSchedule
		let rTeams = teams.filter(tm => tm.isoalph3 === countryCode)
		return rTeams.length > 0 ? rTeams[rTeams.length - 1] : null
	}

	getOneTeamByGroupIdAndPosition(groupId, positionId) {
        const { teams } = this.props.nodes.data.matchSchedule;
        let rteams = teams.filter(tm => tm.group.id === groupId && tm.group.position === positionId)
        return rteams.length > 0 ? rteams[rteams.length - 1] : 
        { 
            id: 9999, 
            flag: 'default.png', 
            isoalph3: groupId+positionId, 
            name: groupId+positionId,
            "player": {
                "name": "",
                "earnings": 0,
                "pic": "default.png"
            },
            "food": {
                "name": "",
                "calories": 0,
                "pic": "default.png"
            },
            "beverage": {
                "name": "",
                "alcoholProof": 0,
                "pic": "default.png"
            }
        }
    }

	getOneMatchById(matchId) {
        const { matchs } = this.props.nodes.data.matchSchedule
        let rmatchs = matchs.filter(mt => mt.id === parseInt(matchId, 0))
        return rmatchs.length > 0 ? rmatchs[rmatchs.length - 1] : null
    }

    emphasysCard = (scrollTop) => {
        this.setState(prev => { 
            return { scrollTop: scrollTop } 
        })
    }

	render() {
		const { children, view, cardIndex, nodes, currentCountryCode } = this.props
		const selected_class = `uvn-fifa2018-view-selected`
		const currentTeam = this.getOneTeamByCoutryCode(currentCountryCode)		

		const currentMatch = this.getOneMatchById(this.props.currentMatchId)
        const currentLeftTeam = this.getOneTeamByGroupIdAndPosition(currentMatch.leftTeam.groupId, currentMatch.leftTeam.position)
        const currentRightTeam = this.getOneTeamByGroupIdAndPosition(currentMatch.rightTeam.groupId, currentMatch.rightTeam.position)

        let leftInfo = ""
        let rightInfo = ""
        switch (this.props.cardIndex) {
        	case 0:
        		leftInfo = currentLeftTeam.food.name
        		rightInfo = currentRightTeam.food.name
        	break;
        	case 1:
        		leftInfo = currentLeftTeam.player.name
        		rightInfo = currentRightTeam.player.name
        	break;
        	case 2:
        		leftInfo = currentLeftTeam.beverage.name
        		rightInfo = currentRightTeam.beverage.name
        	break;
        	default:
        	break;
        }

        return (
			<g.Div className="uvn-fifa2018" postion="relative">
				<g.Div
					onMouseOver={() =>{ this.hideFlags() }}
					className="uvn-fifa2018-header"
					style={{ marginBottom: this.state.stickyNav ? (this.state.height_tools) + 'px' : '' }}>
					<g.Img className="uvn-fifa2018-logo" src={require("./images/logorusia2018.png")} />
					<g.H1 style={ { display: "none" } }>Calendario y horarios del Mundial de Rusia 2018.</g.H1>
					<g.Div className="uvn-fifa2018-desc">
					Este es el calendario completo, con las fechas de los enfrentamientos del Mundial de Rusia 2018.
					</g.Div>
					<g.Div
						display="flex"
						flexDirection="row"
						justifyContent="center"
						alignItems="center"
						className="uvn-fifa2018-desc">
						<g.P padding={0} margin={`0 20px 0 0`}>Compartir:</g.P>
						<SocialShare trackSocial={this.track_social} leftInfo={leftInfo} rightInfo={rightInfo} />
					</g.Div>
				</g.Div>
				<g.Div 	position={ this.state.stickyNav ? `fixed` : `relative`}
						width={`100%`}
						maxWidth={1200}
						zIndex={1000}
						height={"auto"}
						paddingBottom={this.state.px + "px"}
						backgroundColor={`#fff`}
						className={ this.state.stickyNav ? `stickyNav` : `uvn-fifa2018-filters-cont`}
						top={this.state.sumTopsticky}>
					<g.Div className="uvn-fifa2018-filters" minHeight={30}>
						<g.Div className="uvn-fifa2018-list-view-container">
							<g.Ul className="uvn-fifa2018-list-view"
								  float="left"
								  display="flex"
								  flexDirection="row"
								  justifyContent="center"
								  alignItems="center">
								<g.Li		
									borderRadius="16px 0 0 16px"
									borderTop="1px solid #E7E8EB"
									borderBottom="1px solid #E7E8EB"
									borderLeft="1px solid #E7E8EB"																
									className={"uvn-fifa2018-view uvn-fifa2018-date " + (view === "fechas" ? selected_class : ``) }>
									<g.A href="javascript:void(0)"
										width="100%"
										height="100%"
										display="flex"
										flexDirection="row"
										justifyContent="center"
										alignItems="center"
										onClick={(e) => this.selectView("uvn-fifa2018-date", e)}
										onMouseOver={() =>{ this.hideFlags() }}>
										<g.Span>FECHA</g.Span>
									</g.A>
								</g.Li>
								<g.Li
									borderTop="1px solid #E7E8EB"
									borderBottom="1px solid #E7E8EB"
									borderLeft="1px solid #E7E8EB"
									borderRight="1px solid #E7E8EB"
									className={"uvn-fifa2018-view uvn-fifa2018-group " + (view === "grupos" ? selected_class : ``) }>
									<g.A href="javascript:void(0)"
										width="100%"
										height="100%"
										display="flex"
										flexDirection="row"
										justifyContent="center"
										alignItems="center"
										onClick={(e) => this.selectView("uvn-fifa2018-group", e)}
										onMouseOver={() =>{ this.hideFlags() }}>
										<g.Span>GRUPOS</g.Span>
									</g.A>
								</g.Li>								
								<g.Li
									borderRadius="0 16px 16px 0"
									borderTop="1px solid #E7E8EB"
									borderBottom="1px solid #E7E8EB"
									borderRight="1px solid #E7E8EB"
									className={"uvn-fifa2018-view uvn-fifa2018-country"}
									backgroundColor={view === "pais" ? "#E7E8EB" : "#fff" }
									backgroundImage={view === "pais" ? "none !important" : null}>
									<g.A href="javascript:void(0)"
										width="100%"
										height="100%"
										display="flex"
										flexDirection="row"
										justifyContent="center"
										alignItems="center"
										onMouseOver={() => { this.setState({ countriesDisplay: true })}}
										onClick={() => { this.setState({ countriesDisplay: true })}}>
										{
											(view === "pais") ?
											<g.Div
												display="flex"
												flexDirection="row"
												justifyContent="center"
												alignItems="center">
												<g.Img className="nowhite" src={require(`./images/flags/${currentTeam.flag}`)} alt={currentTeam.name} />
												<g.Span marginRight={5} fontWeight={700}>{currentTeam.isoalph3}</g.Span><g.Img className="uvn-fifa2018-arrow-down-gray" src={require("./images/arrow-down-gray.png")} />
											</g.Div> :
											<g.Div
												display="flex"
												flexDirection="row"
												justifyContent="center"
												alignItems="center">												
												<g.Span>PAÍS</g.Span> <g.Img marginLeft={5} className="uvn-fifa2018-arrow-down-gray" src={require("./images/arrow-down-gray.png")} />
											</g.Div>									
										}
									</g.A>
								</g.Li>
							</g.Ul>
						</g.Div>
						{ (!this.isMobile().any()) &&
							<g.Div className="uvn-fifa2018-category">
								<g.Ul className="uvn-fifa2018-list-category">
									<g.Li
										borderRadius="16px 0 0 16px"
										borderTop="1px solid #E7E8EB"
										borderBottom="1px solid #E7E8EB"
										borderLeft="1px solid #E7E8EB"
										onClick={(e) => this.selectCategory("comida-icon", e)}
										onMouseOver={() =>{ this.hideFlags() }}
										className={"category-icon comida-icon" + (cardIndex === 0 ? " uvn-fifa2018-list-category-selected" : "") }>
										<g.Span marginLeft={12}>Comida</g.Span> 
									</g.Li>									
									<g.Li
										borderTop="1px solid #E7E8EB"
										borderBottom="1px solid #E7E8EB"
										borderLeft="1px solid #E7E8EB"
										borderRight="1px solid #E7E8EB"
										onClick={(e) => this.selectCategory("jugador-icon", e)}
										onMouseOver={() =>{ this.hideFlags() }}
										className={"category-icon jugador-icon" + (cardIndex === 1 ? " uvn-fifa2018-list-category-selected" : "") }>
										<g.Span marginLeft={12}>Leyenda</g.Span> 
									</g.Li>
									<g.Li
										borderRadius="0 16px 16px 0"
										borderTop="1px solid #E7E8EB"
										borderBottom="1px solid #E7E8EB"
										borderRight="1px solid #E7E8EB" 																				
										onClick={(e) => this.selectCategory("trago-icon", e)}
										onMouseOver={() =>{ this.hideFlags() }}
										className={"category-icon trago-icon" + (cardIndex === 2 ? " uvn-fifa2018-list-category-selected" : "") }>
										<g.Span marginLeft={12}>Licor</g.Span> 
									</g.Li>									
								</g.Ul>
								<g.Img className="uvn-fifa2018-arrow-down-gray" src={require("./images/arrow-down-gray.png")} />	
								<g.Select id="uvn-fifa2018-category-select" onChange={(e) => this.selectCategory("dropdown-action", e)} className="uvn-fifa2018-category-select">
									<g.Option value="trago-icon">Licor</g.Option>
									<g.Option value="comida-icon">Comida</g.Option>
									<g.Option value="jugador-icon">Leyenda</g.Option>
								</g.Select>
							</g.Div>
						}
					</g.Div>
					{
						this.state.countriesDisplay &&
						<g.Div 
							zIndex="1"
	        			   	position="absolute"
							width="100%"
							//top={this.isMobile().any() ? `70px` : `68px`}
							left="0px"
							height={this.isMobile().any() ? `70px` : `100px`}
							overflowX="scroll"
							overflowY="hidden">
							<CountriesSelect
								set_content_type={this.set_content_type}
								track_click={this.track_click} 
								hideFlags={this.hideFlags}
								gotocountry={this.props.gotocountry}
								teams={nodes.data.matchSchedule.teams} />							
						</g.Div>						
					}
					{ this.state.countriesDisplay && <g.Div className={this.isMobile().any() ? "uvn-fifa2018-countries-mob" : ""}></g.Div>}
				</g.Div>
				<g.Div 
					onMouseOver={() =>{ this.hideFlags() }}
					className="content-view-wrapper"
					paddingTop="10px"
					paddingLeft="10px"
					paddingRight="10px">{children}</g.Div>
				{/* 
				<Tracking tealiumConfig={{
					account: "main", 
					environment: "dev", 
					data: 
					{
						country_code: "us", 
						page_load_timestamp: "1511481769885", 
						page_title: "Worldcup 2018 - Calendar"
					}}} /> */ }
				<UVNUtil />
			</g.Div>
		)
	}
}

class CountriesSelect extends Component {
	
	componentDidMount() {
		setTimeout(() => this.props.hideFlags(), 5000)
	}

	render () {
		return (<g.Div display="flex"					   
        			   flexDirection="row"
        			   flexWrap="nowrap"
        			   justifyContent="flex-start"
        			   alignItems="center"
        			   borderRadius={30}
        			   border="1px solid #E7E8EB"
        			   className="uvn-fifa2018-countries">
					{
						this.props.teams.map((tm, tmk) => {
							return (<g.A
										key={tmk}
										onClick={() => {
											this.props.track_click('CalendarioRusia2018País');
											this.props.gotocountry(tm.isoalph3)
											this.props.hideFlags()
										}}
										href="javascript:void(0)">
										<g.Img src={require(`./images/flags/${tm.flag}`)} alt={tm.name} width="60%" maxWidth={40} />
										<g.Span display="block" textAlign="center">{tm.isoalph3}</g.Span>
									</g.A>)
						})
					}
				</g.Div>)
	}
}

class SocialShare extends Component {

	render() {
		const current_url = "https://www.univision.com/deportes/mundial-rusia-2018/calendario-y-horarios-del-mundial-de-rusia-2018";//(typeof window !== "undefined") ? encodeURIComponent( window.location.href ) : "https://www.univision.com/deportes/"
        const title = ""
        const desc = "¿" + this.props.leftInfo + " vs " + this.props.rightInfo + "? Esta es otra forma, muy divertida, de ver el calendario y los grupos del Mundial de Rusia 2018"
		
		return (<g.Div display="flex"
					   flexDirection="row"
					   alignItems="center"
					   justifyContent="space-between"
					   width={120}
					   height={25}
					   backgroundColor="#fff">
					<g.A width={25}
						 height={25}
						 fontSize={16}
						 css={{':hover': { color: '#42464A', textDecoration: 'none'}}}
						 textAlign="center"
						 lineHeight="25px"
						 color="#E44A4A"
						 onClick={(e) => this.props.trackSocial("FacebookCalendarioMundialRusida2018", e)}
						 href={"https://www.facebook.com/sharer/sharer.php?u=" + current_url + "&quote=" + title} 
						 target="_blank"
						 title="Facebook">
						<i className="fa fa-facebook fa-1x"></i>
					</g.A>
					<g.A width={25}
						 height={25}
						 fontSize={16}
						 css={{':hover': { color: '#42464A', textDecoration: 'none'}}}
						 textAlign="center"
						 lineHeight="25px"
						 color="#E44A4A"
						 onClick={(e) => this.props.trackSocial("TwitterCalendarioMundialRusida2018", e)}
						 href={"https://twitter.com/intent/tweet?source=" + current_url + "&text=" + title + " - " + desc + " " + current_url} 
                         target="_blank" 
                         title="Twitter">
                         <i className="fa fa-twitter fa-1x"></i>
                    </g.A>
                    <g.A width={25}
						 height={25}
						 fontSize={16}
						 css={{':hover': { color: '#42464A', textDecoration: 'none'}}}
						 textAlign="center"
						 lineHeight="25px"
						 color="#E44A4A"
						 onClick={(e) => this.props.trackSocial("EmailCalendarioMundialRusida2018", e)}
						 href={"mailto:?subject=" + title + "&body=" + title + " - " +desc + " " + current_url} 
                         title="Email">
                         <i className="fa fa-envelope fa-1x"></i>
                    </g.A>
				</g.Div>)
	}
}

export default CalendarComponent


// WEBPACK FOOTER //
// ./src/components/calendar/index.js